export default "__VITE_ASSET__CJRWHJkQ__"